import { z } from 'zod';

export const heightSchema = z
  .number()
  .min(50, 'Height must be at least 50 cm')
  .max(250, 'Height must be at most 250 cm');

export const genderSchema = z.enum(['male', 'female', 'other']);

export const wornClothingSchema = z.enum([
  'tight_fitness',
  'underwear',
  'tshirt_jeans',
  'dress_shirt',
  'light_traditional',
  'heavy_traditional',
]);

export function validateHeight(value: unknown): number {
  return heightSchema.parse(value);
}

export function validateGender(value: unknown) {
  return genderSchema.parse(value);
}

export function validateWornClothing(value: unknown) {
  return wornClothingSchema.parse(value);
}
